(function(angular){
	'use strict';
	
	var paginationObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			items: '<',
			pageSize: '<?',
			currentPage: '<'
		},
		controller: [
			'$scope', 
			'mixpanelFactory',
			PaginationFunction
		],
		controllerAs: 'pagination'
	};
	
	angular
		.module('reitElementListingModule')
		.component('pagination', paginationObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/reit-element-container/pagination.html';
	}
	
	function PaginationFunction(
		$scope,
		mixpanelFactory
	){
		var pagination = this;

		pagination.$onInit = function() {
			pagination.currentPage = pagination.currentPage || 0;
			pagination.pages = [];
			pagination.pageSize = pagination.pageSize || 10;
			setupPages();
		};

		pagination.$onChanges = function() {
			setupPages();
		};

		function setupPages() {
			pagination.pages = [];

			if(angular.isDefined(pagination.items)) {
				var numPages = Math.ceil(pagination.items.length/pagination.pageSize);
				
				for(var i = 0; i  < numPages; i++) {
					pagination.pages.push(i);
				}
			}
		}

		function emitChanges() {
			$scope.$emit('pagination:update', {
				currentPage: pagination.currentPage
			});
		}

		pagination.previous = function() {
			pagination.currentPage = pagination.currentPage - 1;

			if(pagination.currentPage === -1) {
				pagination.currentPage = pagination.pages[pagination.pages.length - 1];
			}

			mixpanelFactory.track('Pagination Previous Button', {
				page: pagination.currentPage + 1
			});

			emitChanges();
		};
		
		pagination.next = function() {
			pagination.currentPage = pagination.currentPage + 1;

			if(pagination.currentPage === pagination.pages.length) {
				pagination.currentPage = 0;
			}

			mixpanelFactory.track('Pagination Next Button', {
				page: pagination.currentPage + 1
			});

			emitChanges();
		};
	}
})(window.angular);